:host{
  background: var(--white-layout-301-level-0-elevation);
}

.main-container {
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 2.5);
  max-width: 1300px; //tbd with UX team
  margin: 0 auto;
}

.border-radius {
  border-radius: 4px;
}

.header-banner {
  overflow: hidden;
  position: relative;
  margin-bottom: calc(var(--spacer) * 4.5);

  gz-button {
    &::part(button) {
      min-width: 175px;
    }
  }

  &:after {
    content: '';
    width: 720px;
    height: 720px;
    background: url('app/webcomponents/assets/images/helpAndSupport/emptyStatesExtendedDark.svg') no-repeat;
    position: absolute;
    left: -340px;
    bottom: -125px;
  }
  .links-container {
    display: flex;
    gap: calc(var(--spacer) * 2);
    flex-flow: row wrap;
  }
}

.card.banner {
  background-color: var(--blue-layout-400-primary);
  position: relative;
  overflow: hidden;
}

.master-class-banner {
  &:after {
    content: '';
    width: 500px;
    height: 500px;
    background: url('app/webcomponents/assets/images/helpAndSupport/bd_masterclass.svg') 0 -50px / 120% no-repeat;
    position: absolute;
    top: 0;
    right: 0;
  }
}

.faq-banner {
  margin: 60px 0;
  &:before {
    content: '';
    width: 720px;
    height: 720px;
    background: url('app/webcomponents/assets/images/helpAndSupport/faqAstroman.svg') no-repeat;
    position: absolute;
    top: -75px;
    right: -155px;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: calc(var(--spacer) * 4);
}

.help-and-support-cards-container {
  margin-top: calc(var(--spacer) * 3);
}

.card {
  padding: 35px calc(var(--spacer) * 5);
  background-color: var(--blue-layout-101-background);

  &.header-banner {
    padding: calc(var(--spacer) * 5) calc(var(--spacer) * 5) calc(var(--spacer) * 5) 450px;
  }
  &.master-class-banner {
    padding: calc(var(--spacer) * 5) 550px calc(var(--spacer) * 5) calc(var(--spacer) * 5);
    gz-title,
    gz-text {
      color: var(--white-layout-301-level-0-elevation);
    }
  }
  &.contact-us-card {
    a {
      color: var(--blue-layout-400-primary);
    }
  }
  &.faq-banner {
    padding: calc(var(--spacer) * 5) 500px calc(var(--spacer) * 5) calc(var(--spacer) * 5);
    gz-title {
      color: var(--white-layout-301-level-0-elevation);
    }
    gz-link {
      span {
        color: var(--white-layout-301-level-0-elevation);
      }
    }
  }

  .btns-container {
    padding: 14px 0;
    display: flex;
    flex-flow: row wrap;
    gap: calc(var(--spacer) * 2);
    gz-button.explore {
      &::part(button) {
        padding: 0 calc(var(--spacer) * 3.5);
      }
    }
  }
}

.help-and-support-tab-group {
  gz-tab {
    position: relative;
  }

  &::part(tab-group) {
    overflow: visible;
  }
}

.help-and-support-tab-content {
  padding: 40px 1px;

  gz-card {
    width: 100%;
    height: auto;
    min-height: initial;
    padding-bottom: calc(var(--spacer) * 3);
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 4px;

    &::part(title) {
      font-size: var(--body-size-xxlarge);
      font-weight: 400;
    }

    &::part(icon) {
      min-width: 72px;
    }
  }

  .articles-wrapper {
    flex-wrap: wrap;

    .article {
      margin: 3px 5px 3px 0;
      padding-right: 5px;
      border-right: 2px solid var(--chart-100-pressed);

      &:hover {
        text-decoration: underline;
      }

      span {
        color: var(--body-text-arrows-400);
      }

      &:last-child {
        margin-right: 0;
        padding-right: 0;
        border: none;
      }
    }
  }

  .more-articles-link {
    text-transform: uppercase;
    margin-top: 12px;
  }
}

.legal-card {
  gz-link {
    span {
      color: var(--body-text-arrows-400);
      text-decoration: underline;
    }
  }

  .btns-container {
    flex-direction: column;
  }
}
